import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import store from './store'
import router from './router'
 import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueClipboard)
new Vue({
	store,
	router, // 注入路由
	render: h => h(App),
}).$mount('#app')
